interface KeyFactsBoxProps {
  facts: string[];
}

export default function KeyFactsBox({ facts }: KeyFactsBoxProps) {
  return (
    <div className="border-l-4 border-[#1A1A1A] bg-[#F5F4F0] px-5 py-4 my-6">
      <h4 className="font-['IBM_Plex_Sans',system-ui,sans-serif] font-bold text-[11px] uppercase tracking-[0.1em] mb-3 text-[#0D0D0D]">
        Key Facts
      </h4>
      <ul className="space-y-0">
        {facts.map((fact, i) => (
          <li
            key={i}
            className="font-['Source_Serif_4',Georgia,serif] text-[14px] text-[#2D2D2D] py-[5px] border-b border-[#D4D4D4] last:border-0 pl-4 relative"
          >
            <span className="absolute left-0 top-[7px] text-[#C8102E] text-[10px]">▸</span>
            {fact}
          </li>
        ))}
      </ul>
    </div>
  );
}
